import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import {
  customTextColor,
  formatDate,
  formatTime,
  convertArrayToString,
  formatText,
} from "../../../utils/const";
import { Grid, Typography } from "@mui/material";
import styles from "../Candidate.module.css";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAppliedCandidateById } from "../../../redux/jobTimeline/jobTimelineSlice";
import { useDispatch, useSelector } from "react-redux";

const CandidateSubmisionDrawer = ({
  handleClose,
  show,
  row,
  getPreferLocationNames,
}) => {
  const [jobStatus, setJobStatus] = useState("Applied");
  const [isJonPost, setIsJonPost] = useState(false);
  const [isJonPostIsCall, setIsJonPostIsCall] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const appliedCandidateData = useSelector(
    (state) => state.jobtimeline.appliedCandidateData
  );

  const jobtimelineStatus = useSelector(
    (state) => state.jobtimeline?.viewStaus
  );

  const handleOnClickViewJob = (job) => {
    let jobID = job?.jobId;
    dispatch(getAppliedCandidateById(jobID));
    setIsJonPostIsCall(true);
  };

  useEffect(() => {
    if (
      jobtimelineStatus === "get_applied_candidate_by_id" &&
      isJonPostIsCall
    ) {
      setIsJonPost(true);
    }
  }, [jobtimelineStatus]);

  useEffect(() => {
    if (isJonPost) {
      navigate("/requirement");

      localStorage.setItem(
        "timelineJobDetails",
        JSON.stringify({
          row: appliedCandidateData?.job_details,
          names: "profile_view_candidate",
        })
      );
    }
  }, [isJonPost]);

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "50%",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "right",
          alignItems: "center",
        }}
      >
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ paddingTop: "0" }}>
        <Grid container className={styles.submisionHeading}>
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <Typography
              sx={
                jobStatus === "Applied"
                  ? { backgroundColor: "#2d73b5", color: "#fff" }
                  : {}
              }
              onClick={() => setJobStatus("Applied")}
            >
              Applied ({row?.job_applications?.jobDetails?.length})
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <Typography
              sx={
                jobStatus === "Accepted"
                  ? { backgroundColor: "#2d73b5", color: "#fff" }
                  : {}
              }
              onClick={() => setJobStatus("Accepted")}
            >
              Accepted (
              {
                row?.job_applications?.jobDetails?.filter(
                  (job) => job?.jobStatus === "accepted"
                ).length
              }
              )
            </Typography>
          </Grid>
          {/* <Grid item xs={12} sm={3} md={3} lg={3}>
            <Typography
              sx={
                jobStatus === "Not Fits"
                  ? { backgroundColor: "#2d73b5", color: "#fff" }
                  : {}
              }
              onClick={() => setJobStatus("Not Fits")}
            >
              Not Fits (
              {
                row?.job_applications?.jobDetails?.filter(
                  (job) => job?.jobStatus === "not_fit"
                ).length
              }
              )
            </Typography>
          </Grid> */}
          <Grid item xs={12} sm={4} md={4} lg={4}>
            <Typography
              sx={
                jobStatus === "Submissions"
                  ? { backgroundColor: "#2d73b5", color: "#fff" }
                  : {}
              }
              onClick={() => setJobStatus("Submissions")}
            >
              Submitted (
              {
                row?.job_applications?.jobDetails?.filter(
                  (job) => job?.applicantLastStatus !== undefined
                ).length
              }
              )
            </Typography>
          </Grid>
        </Grid>
        {jobStatus === "Applied" &&
          (row?.job_applications?.jobDetails?.length > 0 ? (
            row?.job_applications?.jobDetails?.map((job) => {
              return (
                <>
                  <Box className={styles.submisionCard}>
                    <Box>
                      <Typography>
                        <b>
                          {job?.recruiterFullName} –{" "}
                          {formatText(job?.recruiterType)}
                        </b>
                      </Typography>
                      <Typography>{job?.jobTitle}</Typography>
                      <Typography>
                        {getPreferLocationNames(job?.location)}
                      </Typography>
                      <Typography>
                        {convertArrayToString(job?.requirementType)}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography>
                        {formatDate(job?.createdAt)},
                        {formatTime(job?.createdAt)}
                      </Typography>
                      <Typography
                        sx={{
                          marginTop: "20px",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => handleOnClickViewJob(job)}
                      >
                        view job
                      </Typography>
                    </Box>
                  </Box>
                  <hr />
                </>
              );
            })
          ) : (
            <Typography sx={{ textAlign: "center", marginTop: "20px" }}>
              No Record Found.
            </Typography>
          ))}

        {jobStatus === "Accepted" &&
          (row?.job_applications?.jobDetails?.filter(
            (job) => job?.jobStatus === "accepted"
          ).length > 0 ? (
            row?.job_applications?.jobDetails
              ?.filter((job) => job?.jobStatus === "accepted")
              .map((job) => {
                return (
                  <>
                    <Box className={styles.submisionCard}>
                      <Box>
                        <Typography>
                          <b>
                            {job?.recruiterFullName} –{" "}
                            {formatText(job?.recruiterType)}
                          </b>
                        </Typography>
                        <Typography>{job?.jobTitle}</Typography>
                        <Typography>
                          {getPreferLocationNames(job?.location)}
                        </Typography>
                        <Typography>
                          {convertArrayToString(job?.requirementType)}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography>
                          {formatDate(job?.createdAt)},
                          {formatTime(job?.createdAt)}
                        </Typography>
                        <Typography
                          sx={{
                            marginTop: "20px",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => handleOnClickViewJob(job)}
                        >
                          View Job
                        </Typography>
                      </Box>
                    </Box>
                    <hr />
                  </>
                );
              })
          ) : (
            <Typography sx={{ textAlign: "center", marginTop: "20px" }}>
              No Record Found.
            </Typography>
          ))}

        {jobStatus === "Not Fits" &&
          (row?.job_applications?.jobDetails?.filter(
            (job) => job?.jobStatus === "not_fit"
          ).length > 0 ? (
            row?.job_applications?.jobDetails
              ?.filter((job) => job?.jobStatus === "not_fit")
              .map((job) => {
                return (
                  <>
                    <Box className={styles.submisionCard}>
                      <Box>
                        <Typography>
                          <b>
                            {job?.recruiterFullName} –{" "}
                            {formatText(job?.recruiterType)}
                          </b>
                        </Typography>
                        <Typography>{job?.jobTitle}</Typography>
                        <Typography>
                          {getPreferLocationNames(job?.location)}
                        </Typography>
                        <Typography>
                          {convertArrayToString(job?.requirementType)}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography>
                          {formatDate(job?.createdAt)},
                          {formatTime(job?.createdAt)}
                        </Typography>
                        <Typography
                          sx={{
                            marginTop: "20px",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => handleOnClickViewJob(job)}
                        >
                          View Job
                        </Typography>
                      </Box>
                    </Box>
                    <hr />
                  </>
                );
              })
          ) : (
            <Typography sx={{ textAlign: "center", marginTop: "20px" }}>
              No Record Found.
            </Typography>
          ))}

        {jobStatus === "Submissions" &&
          (row?.job_applications?.jobDetails?.filter(
            (job) => job?.applicantLastStatus !== undefined
          ).length > 0 ? (
            row?.job_applications?.jobDetails
              ?.filter((job) => job?.applicantLastStatus !== undefined)
              .map((job) => {
                return (
                  <>
                    <Box className={styles.submisionCard}>
                      <Box>
                        <Typography>
                          <b>
                            {job?.recruiterFullName} –{" "}
                            {formatText(job?.recruiterType)}
                          </b>
                        </Typography>
                        <Typography>{job?.jobTitle}</Typography>
                        <Typography>
                          {getPreferLocationNames(job?.location)}
                        </Typography>
                        <Typography>
                          {convertArrayToString(job?.requirementType)}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography>
                          <b>{formatText(job?.applicantLastStatus)}</b>
                        </Typography>
                        <Typography>
                          {formatDate(job?.createdAt)},
                          {formatTime(job?.createdAt)}
                        </Typography>

                        <Typography
                          sx={{
                            marginTop: "20px",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => handleOnClickViewJob(job)}
                        >
                          View Job
                        </Typography>
                      </Box>
                    </Box>
                    <hr />
                  </>
                );
              })
          ) : (
            <Typography sx={{ textAlign: "center", marginTop: "20px" }}>
              No Record Found.
            </Typography>
          ))}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CandidateSubmisionDrawer;
